module.exports = __webpack_public_path__ + "static/media/investments-out.8ac01f55.svg";